<template>
  <div>
    <navbar-component />
    <div class="bg-container">
      <vendor-detail-content-layout :texts="texts"></vendor-detail-content-layout>
    </div>
    <footer-component />
    <whatsapp-component />

  </div>
</template>

<script>
export default {
  name: "VendorDetailView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.vendor[this.selectLanguage];
  },
  methods: {},
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.vendor[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-top: 64px;
}

@media (max-width: 960px) {
  .bg-container {
    padding-top: 60px;
  }
}
</style>